import _ from "lodash";
import InputValidationResult from "@/server/com/silkplm/engine/rpc/validators/InputValidationResult";
import {cloneClassInstance, cloneEntity, isPromise, stringifyForCompare} from "@/utils/Objects";
import DecimalWithCurrency from "@/server/com/silkplm/rpc/dto/DecimalWithCurrency";
import Currency from "@/server/com/silkplm/model/plm/dictionaries/Currency";
import DecimalFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DecimalFormFieldConfig";
import {
    detectDBLanguage,
    detectInputTypingLanguage,
    fillMissingTranslationsAfterLoad,
    prepareMissingTranslationsAfterLoad
} from "@/utils/TranslationDispatcher";
import FormShadowFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormShadowFieldConfig";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";


let executionCounter = 0;
export default class ValidatedField {
    constructor(validatedForm, initialValue, validationFunction = (value, valEqToOriginal) => true) {

        /** @type{ValidatedForm} */
        this.validatedForm = validatedForm;

        /** @type{string} NEW | EDIT */
        this.mode = "NEW";

        /** @type{boolean} */
        this.validationInProgress = false;

        /** @type{boolean} */
        this.detailsLoadInProgress = false;

        /** @type{boolean} */
        this.autoValidated = true;

        /** @type{boolean} */
        this.isValid = undefined;

        /** @type{boolean} */
        this.isChecked = false;

        /** @type{string} */
        this.errorMessage = "";

        /** @type{Function} */
        this.validationFunction = validationFunction;

        /** @type{Function} */
        this.onValidated = null;

        this._chackedValue = null;
        this._timer = null;

        let clonedValue = cloneEntity(initialValue);
        this._value = clonedValue;
        this._stringifiedValue = stringifyForCompare(clonedValue);
        this._stringifiedTranslations = "{}";
        this.initialValue = cloneEntity(initialValue);
        this._stringifiedinitialValue = stringifyForCompare(clonedValue);
        this.alwaysCheck = false;

        this._crossFieldIsValid = true;
        this._fieldIsValid = true;
        /** @type{string} */
        this._fieldErrorMessage = "";

        /** @type{string} */
        this.hintMessage = "";

        this.managedByParent = false;

        /** @type{string} */
        this._crossFieldErrorMessage = "";

        this.onChangeHandlers = [];
        this.onChangeDelayedHandlers = [];
        this.onValidatedHandlers = [];

        this._canSubmit = true;

        this.settingInitialValues = false;

        this.translations = {};
        this.currentRegion = 'def';
        this.delayedUpdatePromise = null;
    }

    get fieldIsValid() {
        return this._fieldIsValid;
    }

    set fieldIsValid(value) {
        this._fieldIsValid = value;
        this.isValid = this._fieldIsValid && this._crossFieldIsValid;
    }

    get crossFieldIsValid() {
        return this._crossFieldIsValid;
    }

    set crossFieldIsValid(value) {
        this._crossFieldIsValid = value;
        this.isValid = this._fieldIsValid && this._crossFieldIsValid;
        //console.log("[CFV]" + this.formFieldConfig?.fieldName + (this.isValid ? " - valid?" : "INV"))
    }

    get fieldErrorMessage() {
        return this._fieldErrorMessage;
    }

    set fieldErrorMessage(value) {
        this._fieldErrorMessage = value;
        this.mixErrorMessage();
    }

    get crossFieldErrorMessage() {
        return this._crossFieldErrorMessage;
    }

    set crossFieldErrorMessage(value) {
        this._crossFieldErrorMessage = value;
        this.mixErrorMessage();
    }

    get value() {
        return this._value;
    }

    set value(value) {
        const old = this._stringifiedTranslations;
        //this.translations[this.currentRegion] = value;

        const stringified = stringifyForCompare(this.translations ?? {});
        let changed = stringified !== this._stringifiedTranslations;
        let newVal = stringifyForCompare(value);
        let oldVal = this._stringifiedValue;
        if(newVal !== oldVal){
            changed = true;
        }
        this._value = value;
        this._stringifiedValue = stringifyForCompare(this._value);

        if (changed) {
            if(this.validatedForm && !this.formFieldConfig?.computed) {
                this.validatedForm.unsavedChanges = true;
            }

            this._stringifiedTranslations = stringified;
            if( this._stringifiedTranslations.includes('pl')){
                // console.log("x");
            }
            this.valueSet(value);
            this.onChangeHandlers.forEach(callback => {
                try {
                    callback(this.baseValue)
                } catch (e) {
                    Log.fatal(e, true);
                }
            });
        }
        if (this.autoValidated && changed && !this.formFieldConfig?.computed) {
            if (this.formFieldConfig instanceof TextFormFieldConfig) {
                this.validateDelayed(1000);
            } else {
                this.validateDelayed();
            }
        } else {
            setTimeout(() => {
                this.onChangeDelayedHandlers.forEach(callback => {
                    try {
                        callback(this.baseValue)
                    } catch (e) {
                        Log.fatal(e, true);
                    }
                });
            });
        }
    }

    get baseValue() {
        if (!SessionManager.applicationUser) {
            return this.value;
        }
        let translatedVal = this.translations[detectDBLanguage(this)];
        if (translatedVal === undefined) {
            return this.value;
        }
        return this.value ?? translatedVal;
    }

    set baseValue(value) {
        if(this.mode == "NEW"){
            return;
        }
        if (!this.isDecimalWithCurrencyRenderer()) {
            this.translations[detectDBLanguage(this)] = cloneEntity(value);
            // console.log(this.translations[detectDBLanguage(this)]);
        }

    }

    get canSubmit() {
        return this._canSubmit;
    }

    set canSubmit(val) {
        this._canSubmit = val;
        this.validatedForm?.refreshValidationState();
    }

    async setRegion(region) {
    }


    isDecimalWithCurrencyRenderer() {
        if (this.formFieldConfig instanceof DecimalFormFieldConfig) {
            if (this.formFieldConfig.dataType === "DecimalWithCurrency") {
                return true;
            }
        }
        return false;
    }

    isInUniqueConstraint() {
        return false;
    }

    onChangeDelayed(callback) {
        this.onChangeDelayedHandlers.push(callback);
    }

    onChange(callback) {
        this.onChangeHandlers.push(callback);
    }

    onValidated(callback) {
        this.onValidatedHandlers.push(callback);
    }

    resetInitialValue(initialValue) {
        let clonedValue = cloneEntity(initialValue);
        this.initialValue = clonedValue;
        this._stringifiedValue = stringifyForCompare(clonedValue);
        this._stringifiedTranslations = stringifyForCompare(this.translations);
        if( this._stringifiedTranslations.includes('pl')){
            // console.log("x");
        }
        this._stringifiedinitialValue = stringifyForCompare(clonedValue);
    }

    resetInitialTranslations() {
        this._stringifiedTranslations = stringifyForCompare(this.translations);
        // if( this._stringifiedTranslations.includes('pl')){
        //     // console.log("x");
        // }
    }

    setInitialValueWithTranslations(initialValue, translationPack, fieldName) {
        if (initialValue?.decimal) {
            if (new BigDecimal(0).equals(initialValue?.decimal)) {
                initialValue.decimal = null;
            }
        }
        let clonedValue = cloneEntity(initialValue);
        this.initialValue = clonedValue;
        this.setInitialValue?.(clonedValue, null, fieldName);
        this.resetInitialValue?.(clonedValue);

        //this._stringifiedinitialValue = stringifyForCompare(initialValue);
        this.baseValue = cloneEntity(initialValue);
        this.translations = {};
        if (!translationPack) {
            translationPack = {};
        }
        for (let reg in translationPack) {
            if (translationPack[reg][fieldName] != null) {
                this.translations[reg] = translationPack[reg][fieldName];
            }
        }

        prepareMissingTranslationsAfterLoad(this);

        this._stringifiedinitialValue = stringifyForCompare(this.translations);
    }

    mixErrorMessage() {
        let errs = [];
        if (this._fieldErrorMessage) {
            errs.push(this._fieldErrorMessage);
        }
        if (this._crossFieldErrorMessage) {
            errs.push(this._crossFieldErrorMessage);
        }
        this.errorMessage = errs.join("; ");
    }

    setInitialValue(value, translations, fieldName) {
        if (!translations) {
            translations = {};
        }
        this.settingInitialValues = true;
        try {
            this.translations = translations;
            if (fieldName !== "_translations") {
                this.translations['def'] = value;
            }

            const stringified = stringifyForCompare(translations);
            let changed = stringified !== this._stringifiedTranslations;
            this._value = value;
            this._stringifiedValue = stringifyForCompare(this._value);

            this._stringifiedTranslations = stringified;
            if(this._stringifiedTranslations.includes('pl')){
                // console.log("x");
            }
            if (changed) {
                this.valueSet(value);
            }
            if (this.autoValidated && changed) {
                this.validateDelayed();
            }
        } finally {
            this.settingInitialValues = false;
        }
    }

    valueSet(newVal) {

    }

    notify() {
        this.value = this._value;
    }

    async waitForDelayedUpdates() {
        if (this.delayedUpdatePromise) {
            await this.delayedUpdatePromise;
        }
    }

    validateDelayed(timeout = 333) {
        let executionNumber = ++executionCounter;
        this.delayedUpdatePromise = new Promise((resolve) => {
            let promises = [];
            this.onChangeDelayedHandlers.forEach(callback => {
                try {
                    promises.push(callback(this.value));
                } catch (e) {
                    Log.fatal(e, true);
                }
            })
            Promise.all(promises).then(() => {
                if (executionCounter === executionNumber) {
                    this.delayedUpdatePromise = null;
                }
                resolve();
            }).catch(reason => {
                if (executionCounter === executionNumber) {
                    this.delayedUpdatePromise = null;
                }
                resolve();
                Log.fatal(reason, true);
            })
        });
        this.isChecked = !this.validationPending();
        this.validatedForm?.refreshValidationState();

        if (this.validationInProgress) {
            return;
        }
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
        this._timer = setTimeout(() => {
            this._timer = null;

            this.validate().then(() => {
                this.isChecked = !this.validationPending()
            });
        }, timeout);
    }

    withLabel(label) {
        this.label = label;
        return this;
    }

    async validate() {
        if (this.validationInProgress || this.__hideHints) {
            return;
        }

        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }

        this.validationInProgress = true;
        this._chackedValue = stringifyForCompare(this.baseValue);

        let validationResult;

        try {
            if (this.managedByParent) {
                validationResult = true;
                this.validationInProgress = false;
            } else {
                try {
                    if (this.validationFunction) {
                        let fun = null;
                        let valEqToOriginal = stringifyForCompare(this._chackedValue) === stringifyForCompare(this.initialValue);
                        if (this.validationFunction.hasOwnProperty(this.mode)) {
                            fun = this.validationFunction[this.mode];
                            validationResult = await Promise.resolve(fun(this.baseValue, valEqToOriginal));
                        } else {
                            if (this.mode === "NEW" || this.alwaysCheck || !valEqToOriginal) {
                                fun = this.validationFunction;
                                validationResult = await Promise.resolve(fun(this.baseValue, valEqToOriginal));
                            } else {
                                validationResult = true;
                            }
                        }
                    } else {
                        validationResult = true;
                    }
                } catch (e) {
                    Log.warn(e, true);
                    validationResult = undefined;
                } finally {
                    this.validationInProgress = false;
                }
            }

            let currentVal = this.baseValue;
            if (stringifyForCompare(currentVal) !== this._chackedValue) {
                this.isChecked = !this.validationPending();
                return this.validate();
            }

            if (validationResult === true || validationResult === null || validationResult === undefined) {
                this.fieldIsValid = true;
                this.fieldErrorMessage = "";
                this.isChecked = !this.validationPending();
                this.validatedForm?.refreshValidationState();
                //console.log("[NAT]" + this.formFieldConfig?.fieldName + " - valid")
                return;
            }
            if (validationResult === false) {
                this.fieldIsValid = false;
                this.fieldErrorMessage = "Invalid value";
                this.isChecked = !this.validationPending();
                this.validatedForm?.refreshValidationState();
                //console.log("[NAT]" + this.formFieldConfig?.fieldName + " - INV")
                return;
            }
            if (typeof validationResult === 'string' || validationResult instanceof String) {
                if (validationResult === "") {
                    this.fieldIsValid = true;
                    this.fieldErrorMessage = "";
                    this.isChecked = !this.validationPending();
                    //console.log("[NAT]" + this.formFieldConfig?.fieldName + " - valid")
                    return;
                }
                this.fieldIsValid = false;
                this.fieldErrorMessage = _.replace(validationResult, "$field", this.label);
                this.isChecked = !this.validationPending();
                this.validatedForm?.refreshValidationState();
                //console.log("[NAT]" + this.formFieldConfig?.fieldName + " - INV")
                return;
            }
            if (validationResult instanceof InputValidationResult) {
                //console.log("[IVR]" + this.formFieldConfig?.fieldName + " - valid?")
                this.fieldIsValid = true;
                this.fieldErrorMessage = "";
                this.validatedForm.extractFieldErrors(validationResult);
                this.mixErrorMessage();
                this.isChecked = !this.validationPending();
                this.validatedForm?.refreshValidationState();
                return;
            }

            if (validationResult.hasOwnProperty("isValid")) {
                this.fieldIsValid = validationResult["isValid"];
                //console.log("[NAT]" + this.formFieldConfig?.fieldName + (this.fieldIsValid ? " - valid" : "INV"))
            }
            if (!this.isValid && validationResult.hasOwnProperty("errorMessage")) {
                if (validationResult["errorMessage"] !== null && typeof validationResult["errorMessage"] === 'string') {
                    this.fieldErrorMessage = _.replace(validationResult["errorMessage"], "$field", this.label);
                } else {
                    this.fieldErrorMessage = validationResult["errorMessage"];
                }
            }

            this.hintMessage = validationResult.hintMessage ?? "";

            this.isChecked = !this.validationPending();
            if (this.onValidated) {
                await Promise.resolve(this.onValidated(validationResult));
            }
            this.validatedForm?.refreshValidationState();
        } finally {
            this.validatedForm?.updateMasterState?.();
            this.onValidatedHandlers.forEach(callback => {
                try {
                    callback(this)
                } catch (e) {
                    Log.fatal(e, true);
                }
            });
        }
    }

    isResultValid(validationResult) {
        if (validationResult?.hintMessage) {
            if (this.fieldErrorMessage) {
                this.fieldErrorMessage += "; " + validationResult.hintMessage;
            } else {
                this.fieldErrorMessage = validationResult.hintMessage;
            }
        }
        return validationResult === true ||
            validationResult === null ||
            validationResult === undefined ||
            validationResult === "" ||
            (validationResult.hasOwnProperty("isValid") && validationResult["isValid"]);
    }

    /**
     * @param {string} fieldName
     * @param {FieldValidationResult} fieldValidationResult
     */
    parseException(fieldValidationResult) {
        //console.log("[EXC]" + this.formFieldConfig?.fieldName + " - ?")

        this.crossFieldIsValid = fieldValidationResult.isValid;
        this.crossFieldErrorMessage = fieldValidationResult.errorMessage;

        if (fieldValidationResult.hintMessage) {
            if (this.fieldErrorMessage) {
                this.fieldErrorMessage += "; " + fieldValidationResult.hintMessage;
            } else {
                this.fieldErrorMessage += fieldValidationResult.hintMessage;
            }
        }


        if (this.crossFieldErrorMessage && this.label)
            this.crossFieldErrorMessage = _.replace(this.crossFieldErrorMessage, "$field", this.label);
    }

    validationPending(trace) {
        if (!this.formFieldConfig || this.formFieldConfig?.computed || this.formFieldConfig instanceof FormShadowFieldConfig) {
            return;
        }
        let baseValueStr = stringifyForCompare(this.baseValue);
        let res = this.validationInProgress ||
            baseValueStr !== this._chackedValue;

        if (res && trace) {
            // console.log(`validationInProgress: ${this.validationInProgress}\n,
            // baseValue: ${stringifyForCompare(this.baseValue)}\n,
            // checkedValue: ${this._chackedValue}\n,
            // validationInProgress ${this.validationInProgress}`
            // );
        }
        return res;
    }
}
